export var ActivityTimeframes;

(function (ActivityTimeframes) {
  ActivityTimeframes[ActivityTimeframes["Today"] = 0] = "Today";
  ActivityTimeframes[ActivityTimeframes["Week"] = 1] = "Week";
  ActivityTimeframes[ActivityTimeframes["Month"] = 2] = "Month";
  ActivityTimeframes[ActivityTimeframes["Year"] = 3] = "Year";
  ActivityTimeframes[ActivityTimeframes["Three Years"] = 4] = "Three Years";
})(ActivityTimeframes || (ActivityTimeframes = {}));